<template>
    <div class="login-container">
        <div class="box">
            <img src="@/assets/logo.png" class="logo" />

            <div class="description">กรอกอีเมลและรหัสผ่านเพื่อทำการเข้าสู่ระบบ POS ของร้านค้า</div>

            <div class="forms">
                <div class="control">
                    <b-icon icon="person-fill" class="icon"></b-icon>
                    <input type="text" placeholder="อีเมล" v-model="formLogin.email" maxlength="100" />
                </div>
                <div class="control">
                    <b-icon icon="lock-fill" class="icon"></b-icon>
                    <input :type="isShowPassword ? 'text' : 'password'" placeholder="รหัสผ่าน" v-model="formLogin.password" maxlength="30" />
                    <button class="show-password" @click="showPassword()"><b-icon icon="eye-fill"></b-icon></button>
                </div>
            </div>

            <div class="action">
                <div class="validation" v-if="validationMessage">{{ validationMessage }}</div>
                <button class="login" @click="login()">เข้าสู่ระบบ</button>
                <button class="forget-pass" @click="openForgetPassword()">ลืมรหัสผ่าน</button>
            </div>
        </div>

        <forget-password-modal-form :isDisplay="isShowForgetPassword" @hide="closeForgetPassword()"></forget-password-modal-form>
    </div>
</template>

<script>
import ForgetPasswordModalForm from '@/components/authentication/ModalForgetPassword';
// import Helper from '@/resources/Helper';

export default {
    components: {
        ForgetPasswordModalForm
    },
    data() {
        return {
            isShowPassword: false,
            isShowForgetPassword: false,
            validationMessage: '',
            formLogin: { email: '', password: '' }
        }
    },
    methods: {
        openForgetPassword() {
            this.isShowForgetPassword = true;
        },
        closeForgetPassword() {
            this.isShowForgetPassword = false;
        },
        async login() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                // const result = await Helper.postAPI(Helper.getApiUrl(), '/api/login', this.formLogin);
                const result = {
                    data: {
                        success: true,
                        token: 'token_example',
                        name: 'Tester User'
                    }
                }; // Mock API response for testing without backend

                if (result.data.success) {
                    localStorage.token = result.data.token;
                    localStorage.profileName = result.data.name;
                    location.href = "/store";
                } else {
                    this.validationMessage = result.data.message;
                    loader.hide();
                }
            }
        },
        validateData() {
            let isValid = true;

            if (!this.formLogin.email.trim()) {
                isValid = false;
                this.validationMessage = 'โปรดกรอกอีเมล';
            } else if (!this.formLogin.password.trim()) {
                isValid = false;
                this.validationMessage = 'โปรดกรอกรหัสผ่าน';
            }

            return isValid;
        },
        showPassword() {
            this.isShowPassword = !this.isShowPassword;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.login-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('../assets/login-bg.jpg') no-repeat no-repeat center center;
    background-size: cover;
    padding: 15px;

    .box {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        max-width: 400px;
        padding: 40px;

        @media only screen and (max-width: $screenLarge) {
            padding: 30px 20px;
        }

        .logo {
            display: block;
            margin: auto;
            max-width: 80%;
        }

        .description {
            font-size: 12px;
            color: #ddd;
            padding: 20px 0 30px;
            text-align: center;

            &:before {
                content: " ";
                display: block;
                margin: 0 auto 20px;
                width: 40px;
                height: 1px;
                background: #555;
            }
        }

        .forms {
            background: rgba(255, 255, 255, 0.4);
            padding: 5px 25px;

            .control {
                position: relative;
                display: flex;
                align-items: center;

                .bi.icon {
                    position: absolute;
                }
                
                input {
                    display: block;
                    width: 100%;
                    font-size: 15px;
                    border: none;
                    background: none;
                    outline: none;
                    padding: 15px 10px 15px 40px;
                }

                .show-password {
                    position: absolute;
                    right: 0;
                    color: #555;
                    cursor: pointer;
                    background: none;
                    border: none;

                }

                &:first-child {
                    border-bottom: 1px solid #333;
                }
            }
        }

        .action {
            padding-top: 25px;

            .validation {
                text-align: center;
                font-size: 13px;
                color: #ff0000;
                padding-bottom: 10px;
            }
            
            button {
                display: block;
                border: none;
                outline: none;
                margin: 5px auto;

                &:hover {
                    opacity: 0.5;
                    text-decoration: underline;
                }
                
                &.login {
                    background: $secondaryColor;
                    color: #000;
                    font-size: 16px;
                    font-weight: bold;
                    padding: 10px 30px;
                    @include transition(all 0.2s linear);
                }

                &.forget-pass {
                    font-size: 15px;
                    margin-top: 15px;
                    background: none;
                    color: #999;
                }
            }
        }
    }
}

::placeholder {
    color: #333;
    opacity: 1;
}
  
:-ms-input-placeholder {
    color: #333;
}
  
::-ms-input-placeholder {
    color: #333;
}
</style>